import { render, staticRenderFns } from "./Miniapp.vue?vue&type=template&id=cb55e32e"
import script from "./Miniapp.vue?vue&type=script&lang=ts"
export * from "./Miniapp.vue?vue&type=script&lang=ts"
import style0 from "./Miniapp.vue?vue&type=style&index=0&id=cb55e32e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports